module.exports = __webpack_public_path__ + "02_glasses_brown.311bc1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/02_glasses_brown.png
// module id = iFKf
// module chunks = 0